//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import WCAG from '@/scripts/libs/wcag/wcag'
import Base from './rb-base.vue'
export default {
  name: 'rb-radio',
  extends: Base,
  model: {
    prop: 'modelValue',
    event: 'change',
  },
  props: {
    title: {
      type: String,
    },
    radioValue: {
      type: String,
    },
    description: {
      type: String,
    },
  },
  methods: {
    changeOnKeypress(e) {
      if (WCAG.isEnterPressed(e)) {
        this.$refs.navigationClick.click()
      }
    },
  },
}
